import * as yup from "yup";

export const searchValidationSchema = yup
  .object({
    barcode: yup.string().trim().required(),
  })
  .required();
